/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */
import {
    HttpClient,
    HttpHeaders,
    HttpResponse as AngularHttpResponse,
} from '@angular/common/http';
import type { HttpContext, HttpEvent, HttpParams } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
    CheckOnboardingStatusRequest,
    CheckOnboardingStatusResponse,
    OnboardingCompleteRequest,
    OnboardingCompleteResponse,
} from '../core-models';

interface HttpClientOptions {
    readonly headers?: HttpHeaders | Record<string, string | string[]>;
    readonly context?: HttpContext;
    readonly params?:
        | HttpParams
        | Record<
              string,
              string | number | boolean | Array<string | number | boolean>
          >;
    readonly reportProgress?: boolean;
    readonly withCredentials?: boolean;
    readonly credentials?: RequestCredentials;
    readonly keepalive?: boolean;
    readonly priority?: RequestPriority;
    readonly cache?: RequestCache;
    readonly mode?: RequestMode;
    readonly redirect?: RequestRedirect;
    readonly referrer?: string;
    readonly integrity?: string;
    readonly referrerPolicy?: ReferrerPolicy;
    readonly transferCache?: { includeHeaders?: string[] } | boolean;
    readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
    readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
    readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
    readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
    readonly observe?: 'body' | 'events' | 'response';
};

@Injectable({ providedIn: 'root' })
export class AuthApiService {
    private readonly http = inject(HttpClient);
    /**
     * Resolves onboarding from persisted invitation context. Joins an existing organisation without renaming it, or establishes the recipient's own organisation. No status pre-check is required.
     * @summary Complete first-login onboarding
     */
    completeAuthOnboarding<TData = OnboardingCompleteResponse>(
        onboardingCompleteRequest: OnboardingCompleteRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    completeAuthOnboarding<TData = OnboardingCompleteResponse>(
        onboardingCompleteRequest: OnboardingCompleteRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    completeAuthOnboarding<TData = OnboardingCompleteResponse>(
        onboardingCompleteRequest: OnboardingCompleteRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    completeAuthOnboarding<TData = OnboardingCompleteResponse>(
        onboardingCompleteRequest: OnboardingCompleteRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/auth/onboarding/complete`,
                onboardingCompleteRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/auth/onboarding/complete`,
                onboardingCompleteRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/auth/onboarding/complete`,
            onboardingCompleteRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
    /**
     * Returns a minimal onboarding status summary for the supplied email without exposing organisation details.
     * @summary Check onboarding status for an invited user
     */
    createAuthOnboardingStatu<TData = CheckOnboardingStatusResponse>(
        checkOnboardingStatusRequest: CheckOnboardingStatusRequest,
        options?: HttpClientBodyOptions
    ): Observable<TData>;
    createAuthOnboardingStatu<TData = CheckOnboardingStatusResponse>(
        checkOnboardingStatusRequest: CheckOnboardingStatusRequest,
        options?: HttpClientEventOptions
    ): Observable<HttpEvent<TData>>;
    createAuthOnboardingStatu<TData = CheckOnboardingStatusResponse>(
        checkOnboardingStatusRequest: CheckOnboardingStatusRequest,
        options?: HttpClientResponseOptions
    ): Observable<AngularHttpResponse<TData>>;
    createAuthOnboardingStatu<TData = CheckOnboardingStatusResponse>(
        checkOnboardingStatusRequest: CheckOnboardingStatusRequest,
        options?: HttpClientObserveOptions
    ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
        if (options?.observe === 'events') {
            return this.http.post<TData>(
                `/@core/api/auth/onboarding/status`,
                checkOnboardingStatusRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'events',
                }
            );
        }

        if (options?.observe === 'response') {
            return this.http.post<TData>(
                `/@core/api/auth/onboarding/status`,
                checkOnboardingStatusRequest,
                {
                    ...(options as Omit<
                        NonNullable<typeof options>,
                        'observe'
                    >),
                    observe: 'response',
                }
            );
        }

        return this.http.post<TData>(
            `/@core/api/auth/onboarding/status`,
            checkOnboardingStatusRequest,
            {
                ...(options as Omit<NonNullable<typeof options>, 'observe'>),
                observe: 'body',
            }
        );
    }
}

export type CompleteAuthOnboardingClientResult =
    NonNullable<OnboardingCompleteResponse>;
export type CreateAuthOnboardingStatuClientResult =
    NonNullable<CheckOnboardingStatusResponse>;
